/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import { CircularProgress } from "@mui/material";
import { observer } from "mobx-react";
import React, { lazy, Suspense } from "react";
import "./bootstrap/dayjsSetup";
import "./i18n";

const BootstrapComponent = lazy(() => import("./bootstrap/BootstrapComponent"));

// remove all old and lingering service workers
navigator.serviceWorker.getRegistrations().then((registrations) => {
  for (const registration of registrations) {
    registration.unregister();
  }
});

const App: React.FC = () => (
  <Suspense fallback={<CircularProgress />}>
    <BootstrapComponent />
  </Suspense>
);

export default observer(App);
